import React, { useEffect, useState } from "react";
import axios from "axios";
import "./index.css";
import env from "../../../../../../config/env";
import toast from "react-hot-toast";
import CommonModal from "../../../ResetContext/components/DumpModal";
import Select from "react-select";
import ContactToSupportModal from "../../../../../../components/ContactToSupportModal";
import { useUsersContext } from "../../../../../../context/usersContext";

const Modal = ({ isOpen, onClose, children }) => {
  const BASE_URL = `${env.API_URL}/v1`;
  return (
    <>
      {isOpen && (
        <CommonModal
          title="Add Team Member"
          isOpen={isOpen}
          onClose={onClose}
          showAlert={false}
        >
          {children}
        </CommonModal>
      )}
    </>
  );
};

// Example usage in another component
const AddUserModal = ({
  isModalOpen,
  justCloseIt,
  getLocationUsers = () => { },
  user,
  userActiveLocation,
  activeplans,
  locationUsers,
  setActiveTab,
  setPricingHeading,
}) => {
  const BASE_URL = `${env.API_URL}/v1`;
  const [processing, setProcessing] = useState(false);

  // prompt payload states
  const [userName, setUserName] = useState();
  const [userEmail, setUserEmail] = useState();
  const [userRole, setUserRole] = useState();

  // error status
  const [userNameError, setUserNameError] = useState(null);
  const [userEmailError, setUserEmailError] = useState(null);
  const [userRoleError, setUserRoleError] = useState(null);
  const [openLimitModal, setOpenLimitModal] = useState(false)
  const { products, isHighestPlan } = useUsersContext()

  const resetAddUserForm = () => {
    setUserName("");
    setUserEmail("");
    setUserRole("");
  };
  const handleClose = () => {
    justCloseIt();
  };
  const [userLimitReached, setuserLimitReached] = useState(false);
  const handleAddUserSubmit = async () => {
    setProcessing(true);
    // Reset all previous errors
    setUserNameError(null);
    setUserEmailError(null);
    setUserRoleError(null);
    let hasError = false;
    // Validate the required fields
    if (!userName) {
      setUserNameError("User Name is required");
      hasError = true;
    }
    if (!userEmail) {
      setUserEmailError("Email is required");
      hasError = true;
    }

    if (!userRole) {
      setUserRoleError("Role is required");
      hasError = true;
    }

    if (hasError) {
      setProcessing(false);
      return;
    }

    if (
      activeplans &&
      locationUsers.length >= parseInt(activeplans.user_limit) &&
      userActiveLocation.type === "premium"
    ) {
      setuserLimitReached(true);
      return;
    }

    if (
      userActiveLocation.type === "free" &&
      locationUsers.length >= userActiveLocation?.number_of_team_member
    ) {
      setuserLimitReached(true);
      return;
    }

    try {
      const response = await axios.post(`${BASE_URL}/user/team-member`, {
        userName: userName,
        email: userEmail,
        role: userRole,
        agency_id: userActiveLocation?.agency_id,
        activeLocation: [userActiveLocation?.id],
        password: "password",
        user_id: Math.random(),
      });
      setProcessing(false);

      if (response) {
        toast.success("User added successfully");
        handleClose();
        resetAddUserForm();
        getLocationUsers();
      }
    } catch (err) {
      toast.error(err.response.data.message);
      setProcessing(false);
    }
  };

  useEffect(() => {
    const activePlan = products?.find(item => item?.activePlan === true)
    if (userLimitReached) {
      setTimeout(() => {
        if (userActiveLocation?.type === 'free' || (!activePlan?.isenable_account && !activePlan?.developer_plan) || isHighestPlan())
          setOpenLimitModal(true)
        else {
          setActiveTab("Pricing");
          setPricingHeading("Upgrade to add more team members");
        }
      }, 500);
    }
  }, [userLimitReached]);

  // Role options for the dropdown
  const roleOptions = [
    {
      value: "admin",
      label: (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center",
          }}
        >
          <span>Admin</span>
          <span style={{ color: "#888", fontSize: 14, margin: 0 }}>
            Create and Edit AI Agents
          </span>
        </div>
      ),
      description: "Create and Edit AI Agents",
    },
    {
      value: "user",
      label: (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center",
          }}
        >
          <span>User</span>
          <span style={{ color: "#888", fontSize: 14, margin: 0 }}>
            Use AI Agents
          </span>
        </div>
      ),
      description: "Use AI Agents",
    },
  ];

  // Custom styles for react-select to match the image
  const customSelectStyles = {
    control: (provided, state) => ({
      ...provided,
      borderRadius: 8,
      borderColor: "#e5e5e5",
      minHeight: 58,
      boxShadow: state.isFocused ? "0 0 0 2px #e5e5e5" : "none",
      fontSize: 16,
      fontWeight: 400,
      paddingLeft: 8,
      background: "#fff",
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: "0 8px",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#222",
      fontSize: 16,
      fontWeight: 400,
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: 12,
      marginTop: 4,
      boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
      padding: 0,
      overflow: "hidden",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#f5f5f5"
        : state.isFocused
          ? "#fafafa"
          : "#fff",
      color: "#222",
      fontSize: 16,
      fontWeight: 400,
      padding: "20px 24px",
      display: "flex",
      alignItems: "center",
      borderBottom: "1px solid #f0f0f0",
      cursor: "pointer",
      justifyContent: "space-between",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#222",
      fontSize: 18,
      fontWeight: 400,
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: "#222",
      paddingRight: 16,
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
  };

  // Find the selected option object for react-select
  const selectedRoleOption = roleOptions.find((opt) => opt.value === userRole);

  return (
    <div>
      <Modal isOpen={isModalOpen} onClose={justCloseIt}>
        {userLimitReached && <p>User Limit Reached</p>}
        <div>
          <div style={{ position: "relative" }}>
            <div
              className="formGroup !border border-[#d9d9d9] !rounded-lg !p-3"
              style={{ marginBottom: "20px" }}
            >
              <input
                type="text"
                name="username"
                placeholder="Name"
                className="flex-1 !p-0 !border-0"
                value={userName}
                onChange={(e) => {
                  setUserName(e.target.value);
                  setUserNameError(null);
                }}
              />
              {userNameError && (
                <small style={{ color: "red" }}>{userNameError}</small>
              )}
            </div>
            <div
              className="formGroup !border border-[#d9d9d9] !rounded-lg !p-3"
              style={{ marginBottom: "20px" }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              ></div>
              <input
                type="text"
                name="name@email.com"
                placeholder="User Email"
                className="flex-1 !p-0 !border-0"
                value={userEmail}
                onChange={(e) => {
                  setUserEmail(e.target.value);
                  setUserEmailError(null);
                }}
              />
              {userEmailError && (
                <small style={{ color: "red" }}>{userEmailError}</small>
              )}
            </div>
            <div className="formGroup" style={{ marginBottom: "20px" }}>
              <Select
                options={roleOptions}
                value={selectedRoleOption || null}
                onChange={(option) => {
                  setUserRole(option.value);
                  setUserRoleError(null);
                }}
                placeholder="Select role"
                styles={customSelectStyles}
                isSearchable={false}
                components={{
                  // Remove react-select indicator separator
                  IndicatorSeparator: () => null,
                }}
              />
              {userRoleError && (
                <small style={{ color: "red" }}>{userRoleError}</small>
              )}
            </div>
            <p
              className="disagreeBtn !py-4"
              style={{
                margin: 0,
                width: "100%",
                opacity: processing ? 0.6 : 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              disabled={processing}
              onClick={handleAddUserSubmit}
            >
              {processing && <div className="spinner !w-5 !h-5"></div>}
              Save Changes
            </p>
          </div>
        </div>
      </Modal>
      <ContactToSupportModal isOpen={openLimitModal} onClose={() => setOpenLimitModal(false)} />
    </div>
  );
};

export default AddUserModal;
